import { useCustomValuesByField } from "PFCore/hooks/queries/custom_fields/admin";
import { useCustomType } from "PFCore/hooks/queries/custom_fields/use_custom_type";
import { useState } from "react";

export const useCustomValuesPage = (id) => {
  const [page, setPage] = useState(1);
  const [customValuesParams, setCustomValuesParams] = useState({});

  const {
    data: customValues,
    error: customValuesError,
    isFetching: customValuesFetching
  } = useCustomValuesByField(id, page, 30, customValuesParams);
  const {
    data: customType,
    error: customTypeError,
    isFetching: customTypeFetching,
    isLoading
  } = useCustomType(id);

  const errors = customTypeError || customValuesError;

  return {
    isLoaded: !isLoading,
    isFetching: customTypeFetching || customValuesFetching,
    customValues: customValues || {},
    customType,
    setPage,
    setCustomValuesParams,
    errors
  };
};
